import React, {useState, useContext, useRef} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol } from '@ionic/react';
import { IonImg, IonLabel } from '@ionic/react';
import {Plugins, CameraResultType } from '@capacitor/core';

import '../../css/layout.css';
import {  UploadedInvoiceTemplates } from '../components/Zasava_merchantAccountSettingAppComps';

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';
import { App_Header } from '../components/App_Header';



const { Filesystem } = Plugins;
const { Camera } = Plugins;


//export class Hotel_AccountSetting extends React.Component {
export function Hotel_AccountSetting () {

    let authenticated_Zasava_Context = useContext(Auth_Zasava_Context);


    const [acctID, setAcctID] = useState(authenticated_Zasava_Context.acctID);
    const [schema, setSchemaName] = useState(authenticated_Zasava_Context.schema);
    let [sessionID, setSessionID ] = useState(authenticated_Zasava_Context.sessionID);
    let [showInvoiceTemplates, setShowInvoiceTemplates] = useState(false);
    let [showCompanySetting_selectedImageModal, setShowCompanySetting_selectedImageModal] = useState(false);
    let [enlarge_selectedShowcaseImage, setEnlarge_selectedShowcaseImage] = useState(null);


    let [baseURL, setBaseURL ] = useState(authenticated_Zasava_Context.baseURL);
    let [selectedFile, setSelectedFile] = useState(null);


function saveUploadedFile(event) {
    
        setSelectedFile(event)

    }



    async function uploadFile() {

        alert('In UploadedFile');
        alert(selectedFile);

        let formData = new FormData();
        formData.append('xImageFile', selectedFile);
        formData.append('Tracker', '72003');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }

        fetch(baseURL+'zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);

        })
    }


    //alert('In Account Setting ');

    return (
            <React.Fragment>
            <App_Header></App_Header>

            <IonContent className='appContent'>
                <IonGrid>
                    <IonRow>
                        <IonCol size='6'>
                            <h3>Upload Invoice Template</h3>
                        </IonCol>
                        <IonCol size='6'>
                            <form id='fileUpload' enctype='multipart/form-data'>
                                <input type='file' name='xImageFile' accept="image/*" onChange={(e) => saveUploadedFile(e.target.files[0])}></input>
                                <input type="button" value="upload" onClick={uploadFile} ></input>
                            </form>
                            <IonButton onClick={() => setShowInvoiceTemplates(true)}>View Invoice Uploaded</IonButton>
                        </IonCol>
                    </IonRow>


                </IonGrid>

                <IonModal id='showInvoiceTemplates' isOpen={ showInvoiceTemplates }>
                    <UploadedInvoiceTemplates accountID= { acctID } schemaName={ schema }/>

                    <IonButton onClick={() => setShowInvoiceTemplates(false)}>
                        Close Modal
                    </IonButton>
                </IonModal>


                <IonModal id='showCompanySetting_selectedImage' isOpen={showCompanySetting_selectedImageModal}>
                        <IonGrid>
                            <IonRow>
                                <IonCol>
                                    <IonImg
                                            class='zProServiceShowcase_img'
                                            src={enlarge_selectedShowcaseImage} 
                                        ></IonImg>
                                        <IonButton onClick={() => setShowCompanySetting_selectedImageModal(false)}> Close </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonModal>

            </IonContent>

            </React.Fragment>
            
    );
};



export default Hotel_AccountSetting;